import {OutfitScoreDiagnostic} from '../components/OutfitScoreBadge';

/**
 * Перевод диагностик движка OutfitScore в человеческие причины (UX-аудит 16.09, F09).
 *
 * Бэкенд отдаёт готовые `reasons`/`cautions` там, где возвращает полный результат оценки
 * (`POST /outfits/score`, образ дня). Там, где клиент получает только топ-диагностики
 * (варианты образа дня на главной), те же фразы выводятся здесь — по тем же кодам, что и
 * в `OutfitScoreExplainer` на сервере, чтобы формулировки не расходились.
 *
 * Числа («0.98 +26.4») сознательно не попадают в эти фразы: они остаются в «Деталях расчёта».
 */

const REASON_BY_CODE: Record<string, string> = {
    REINFORCING_FORMALITY: 'Формальность вещей совпадает',
    REINFORCING_STYLE_COHESION: 'Единый стиль',
};

const CAUTION_BY_CODE: Record<string, string> = {
    FORMALITY_GAP: 'Вещи разного уровня формальности',
    STYLE_CONFLICT: 'Стили вещей спорят между собой',
    SEASON_MISMATCH: 'Вещи из разных сезонов',
    PATTERN_OVERLOAD: 'Слишком много узоров в одном образе',
    DETAIL_OVERLOAD: 'Слишком много деталей и декора',
    PALETTE_NOISE: 'Цвета из разных палитр',
    SUPPRESSED_BY_ROLE: 'Есть конфликт, но на второстепенной вещи',
    INVALID_DUPLICATE_ITEM: 'Одна и та же вещь добавлена дважды',
    INVALID_NO_SLOT: 'У вещи не определена роль в образе',
};

/** Максимум фраз в каждом списке — больше трёх верхний уровень уже не читается. */
export const MAX_SCORE_PHRASES = 3;

function phrases(diagnostics: OutfitScoreDiagnostic[] | undefined, dict: Record<string, string>,
                 reinforcing: boolean): string[] {
    const out: string[] = [];
    for (const d of diagnostics ?? []) {
        const isReinforcing = d.severity === 'REINFORCING';
        if (isReinforcing !== reinforcing) continue;
        const phrase = dict[d.code];
        if (phrase && !out.includes(phrase)) out.push(phrase);
        if (out.length >= MAX_SCORE_PHRASES) break;
    }
    return out;
}

/** Причины «почему образ работает» из усиливающих диагностик. */
export function reasonsFromDiagnostics(diagnostics?: OutfitScoreDiagnostic[]): string[] {
    return phrases(diagnostics, REASON_BY_CODE, true);
}

/** Конфликты образа из предупреждающих диагностик. */
export function cautionsFromDiagnostics(diagnostics?: OutfitScoreDiagnostic[]): string[] {
    return phrases(diagnostics, CAUTION_BY_CODE, false);
}
